import { useEffect, useState } from "react";
import { api } from "../../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogle = (intent = "login") => {
  sessionStorage.setItem("olm_oauth_intent", intent);
  const redirectUrl = window.location.origin + "/account/oauth";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const startApple = (intent = "login") => {
  window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/members/oauth/apple/start?intent=${intent}`;
};

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3l5.7-5.7C34 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.6-.4-3.9z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C36.9 39.2 44 34 44 24c0-1.3-.1-2.6-.4-3.9z"/></svg>
);
const AppleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/></svg>
);

export const SocialButtons = ({ intent = "login", className = "" }) => {
  const [appleOn, setAppleOn] = useState(false);
  useEffect(() => { api.get("/members/oauth/apple/enabled").then((r) => setAppleOn(r.data.enabled)).catch(() => {}); }, []);
  return (
    <div className={`space-y-3 ${className}`}>
      <button type="button" onClick={() => startGoogle(intent)} data-testid="continue-google-btn"
        className="w-full inline-flex items-center justify-center gap-3 rounded-full border border-black/15 bg-white py-3.5 text-sm font-medium hover:border-black/40 transition-colors">
        <GoogleIcon /> Continue with Google
      </button>
      {appleOn && (
        <button type="button" onClick={() => startApple(intent)} data-testid="continue-apple-btn"
          className="w-full inline-flex items-center justify-center gap-3 rounded-full bg-[#0A0A0A] text-white py-3.5 text-sm font-medium hover:bg-black/80 transition-colors">
          <AppleIcon /> Continue with Apple
        </button>
      )}
    </div>
  );
};
